const addStaffPage = () =>
  import('@/views/main/staff/base-ui/add-staff/add-staff.vue')
export default {
  path: '/main/staff/addStaffPage',
  name: 'addStaffPage',
  component: addStaffPage,
  children: []
}
